<div class="row basic-component">
    <div class="col-sm-12">
        <form [formGroup]="labelerForm" name="labelerForm" novalidate role="form">
            <div class="row">
                <!-- <div class="col-sm-12 section-title pull-left">
                    Labeler
                </div> -->
                <div class="col-sm-12 section-title">
                  <span>Labeler</span>
                  <span class="float-end create-company-link" *ngIf="canCreateCompany">
                    <a href="javascript:void(0);" (click)="showCompanyDialog()"
                        class="create-company-link" id="create-company" (keydown.enter)="showCompanyDialog()" tabindex="0"><small>Create new company</small></a>
                  </span>
              </div>
            </div>
            <div class="row">
                <div class="col-sm-12 no-padding">
                    <table class="table table-inline table-bordered">
                        <tbody>
                            <tr>
                                <th class="text-center">
                                    <label id="lCompanyRevisionId-lable" aria-label="Company Name / Company DUNS" class="form-label-control">Company Name / Company DUNS</label>
                                </th>
                                <th class="text-center">
                                    <label class="form-label-control" aria-label="NDC Code or Other/Private NDC Code">NDC Code or Other/Private NDC Code</label>
                                </th>
                            </tr>
                            <tr>
                                <td class="td-50">
                                    <div class="row">
                                        <div class="form-group col-sm-12">
                                            <ejs-dropdownlist #lCompanyDdw [dataSource]="companyDataSource"
                                                              [fields]="companyFields" [placeholder]="waterMark" allowFiltering=true filterType="Contains"
                                                              (change)="lCompanySelectionChanged($event)" [popupHeight]="ddwHeight"
                                                              aria-labelledby="lCompanyRevisionId-lable"
                                                              [(value)]="lCompanyRevisionId" formControlName="lCompanyRevisionId">
                                            </ejs-dropdownlist>
                                            <div *ngIf="missingLabelerError" class="alert-text validation-error">
                                                Labeler company required
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="company$ | async as company">
                                          <app-warning-icon #warningContact [name]="'(' + company?.companyDetails?.duns + ') ' + company?.companyDetails?.companyName" [type]="iconTypeCompany"></app-warning-icon>
                                      </div>
                                    </div>
                                </td>

                                <td>
                                    <div class="row">
                                        <div class="col-sm-12">
                                          <div class="row">
                                            <div class="col-sm-6">
                                              <div class="row">
                                                <div class="col-sm-2">
                                                  <ejs-radiobutton name="ndc" value="multi"
                                                                   (change)="ndcRadioChanged($event)"
                                                                   formControlName="ndcType">
                                                  </ejs-radiobutton>
                                                </div>
                                                <div class="col-sm-10">
                                                  <ejs-dropdownlist #ndcDdw [dataSource]="ndcDataSource"
                                                                    formControlName="ndcLabelerCode"
                                                                    [fields]="ndcFields" [placeholder]="waterMark"
                                                                    [popupHeight]="ddwHeight"  (change)="lNdcSelectionChanged($event)">
                                                  </ejs-dropdownlist>
                                                </div>
                                              </div>
                                            </div>

                                            <div class="col-sm-6">
                                              <div class="row">
                                                <div class="col-sm-2">
                                                  <ejs-radiobutton name="ndc" value="single"
                                                                   (change)="ndcRadioChanged($event)"
                                                                   formControlName="ndcType">
                                                  </ejs-radiobutton>
                                                </div>
                                                <div class="col-sm-10">
                                                  <input type="text" id="ndcSingle" class="form-control" autocomplete="off"
                                                         formControlName="userNdcLabelerCode"  (blur)="privateNdcCodeChanged($event)"  (keydown.tab)="onTabPressed($event)" disabled />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                    </div>

                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>

        </form>
    </div>
</div>

<ejs-dialog #confirmDialogCompany [isModal]='isModal' [buttons]='confirmDlgButtonsCompany' [visible]='compHidden'
    [position]='position' [animationSettings]='animationSettings' [width]='modalWidth'>
    <ng-template #content>
      <div class="card">
        <div class="card-header bg-primary">
            <h3 class="card-title text-white" tabindex="0">Labeler Company Update</h3>
        </div>
        <div class="card-body" tabindex="0">
          Current labeler code value will be updated with the new labeler code value in the following areas:
          <ul>
            <li>NDC Product Code</li>
            <li>NDC Packaging Code</li>
            <li>NDC Product Code to establishment link</li>
          </ul>
        </div>
      </div>
    </ng-template>
</ejs-dialog>

<ejs-dialog #confirmDialogNDC [isModal]='isModal' [buttons]='confirmDlgButtonsNDC' [visible]='ndcHidden'
    [position]='position' [animationSettings]='animationSettings' [width]='modalWidth'>
    <ng-template #content>
      <div class="card">
        <div class="card-header bg-primary">
            <h3 class="card-title text-white" tabindex="0">Labeler Company Update</h3>
        </div>
        <div class="card-body" tabindex="0">
          Current labeler code value will be updated with the new labeler code value in the following areas:
          <ul>
            <li>NDC Product Code</li>
            <li>NDC Packaging Code</li>
            <li>NDC Product Code to establishment link</li>
          </ul>
        </div>
      </div>
    </ng-template>
</ejs-dialog>

<!-- Company Detail Dialog box -->
<ejs-dialog id='dialog' #companyDialog isModal='true'
            [animationSettings]='animationSettings' [visible]='hidden' width="80%">
    <ng-template #content class="modal-header">
        <form name="modalCompanyForm" role="form">
            <div class="card">
                <div class="card-header bg-primary">
                    <h4 class="card-title text-white" tabindex="0">Company Details</h4>
                </div>

                <div class="card-body">
                    <app-company-details #companyDetails (companyOutput)="modalCompany($event)"
                        (cancelButtonClickedOutput)="companyDialogCancelButtonClicked()"
                        [parentComponentInput]="parentComponent">
                    </app-company-details>
                </div>

            </div>

        </form>
    </ng-template>
</ejs-dialog>

